import styled, { css } from 'styled-components';

export const TabbarWrapper = styled.div`
  overflow: ${props => (props.isTennis ? 'hidden' : 'visible')};
  ul.scroll-ul {
    display: flex !important;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    overflow-x: ${props => (props.isTennis ? 'hidden' : 'auto')};
    justify-content: ${props => (props.justifyContent ? props.justifyContent : (!props.isTennis ? 'space-between' : ''))};
    margin-top: ${props => (props.isSpecialChampionship ? '-10px' : '10px')};
    border-bottom: ${props => (props.isTennis ? `1px solid ${props.theme.colors.gray}` : 'none')};
    margin-bottom: ${props => (props.isTennis ? '16' : '0')}px;
    ${props => props.theme.mediaQueries.tablet_big_down}{
      margin-top: ${props => (props.isSpecialChampionship ? '-8px' : '0px')};
      justify-content: center;
      padding-bottom: 0px;
        ${props => props.isTennis && css`
          overflow: auto;
          white-space: nowrap;
          justify-content: flex-start !important;
          li span {
            display: inline-block;
            font-size: 18px !important;
            line-height: 1.2 !important;
            height: auto !important;
          }
        `};
    };
  };
  li {
    margin-left: ${props => (props.justifyContent ? '15px' : '0')};
    ${props => props.theme.mediaQueries.big_desktop}{
      margin-left: ${props => (props.justifyContent ? '25px' : '0')};
    }
  }
  li:first-child {
    margin-left: ${props => (props.justifyContent ? '15px' : '0')};
  }
`;

export const DaysMenu = styled.ul`
  display: flex !important;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'space-between')};
  margin-bottom: 15px;
  ${props => !props.isSpecialChampionship && css`
    margin-top: 15px;
  `};
`;

export const MainTabbarWrapper = styled.div`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/CalendarTabbar/styles.js